module.exports = __webpack_public_path__ + "img/Layer_1(1).2a7df46b.svg";